import type { Mob } from "../mob";
import { XY } from "../xy";

export interface MobClass {
	key: string;
	new (xy: XY): Mob;
}

export interface MobGenerationConfig {
	mobSupplier: () => Mob;
	amountMin: number;
	amountMax: number;
}

export function mobs(mobClass: MobClass, amountMin: number, amountMax: number): MobGenerationConfig {
	return { mobSupplier: () => new mobClass(new XY(0, 0)), amountMin, amountMax };
}
